import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { CampaignApi } from "../utils/api";
import { Loader } from "../utils/Loader";
import { VoteForm } from "../components/VoteForm";
import { useTranslation } from "react-i18next";
import { Localization } from "../components/Localization";

export function Campaign() {
  const { uuid, stand } = useParams();
  const navigate = useNavigate();

  const { i18n } = useTranslation();

  const [ campaign, setCampaign ] = useState(null);

  useEffect(() => {
    CampaignApi.getByUuid(uuid).then( response => {
      setCampaign(response);
      document.title = response.translations?.[i18n.language]?.title || response.title;
      document.description = response.translations?.[i18n.language]?.description || response.description;
    }).catch( () => {
      navigate('/');
    });
  }, []);

  if (!campaign) return <Loader />

  const rawText = campaign.translations?.[i18n.language]?.description || campaign.description;
  const processedText = rawText.replace('!campaign_title!', campaign.translations?.[i18n.language]?.title || campaign.title);

  return (
    <div className="stand-wrapper">
      <div className="stand-wrapper_container">
        <div className="stand-header">
          <div className="stand-header_title">
            { campaign.translations?.[i18n.language]?.title || campaign.title }
          </div>
          <Localization styles={{ top: "50%", transform: "translate(-5%, -50%)" }} />
        </div>
        <div className="stand-body">
          <div className="stand-description">
            <div dangerouslySetInnerHTML={{
              __html: processedText
            }}/>
          </div>

          <VoteForm campaign={campaign} stand={stand} />
        </div>
      </div>
    </div>
  )
}
